import { WebPageJsonLd } from 'next-seo';
import { controller } from 'src/switch-themes';

// type Props = {
//   meta?: IMeta;
// };

const { description, name } = controller;

export const HeadVideoPageGallery = () => {
  return <></>;
};

export const BodyVideoPageGallery = () => {
  return (
    <>
      <WebPageJsonLd description={description} id={name.en} />
    </>
  );
};
